<div class="item-inner req-err text-center" data-crlat="requestError">
    @if (loginNeed) {
        <div>
            <p data-crlat="textMsg" [textContent]="errorMsg"></p>
            <button class="btn btn-style1" (click)="openLoginDialog()" data-crlat="signInButton" [disabled]="loginPending">
                <span [class.btn-spinner]="loginPending" data-crlat="spinner.loader"></span>
                <span [i18n]="'app.signIn'"></span>
            </button>
        </div>
    }
    @if (isServerError) {
        <div>
            <p [i18n]="'app.requestErrorMessage'"></p>
            <button class="btn btn-style1" (click)="reloadSection()" data-crlat="refresh">
                @if (!reloadPending) {
                    <span [i18n]="'app.tryAgain'"></span>
                }
                <span [class.btn-spinner]="reloadPending" data-crlat="spinner.loader"></span>
            </button>
        </div>
    }
</div>
